/* 🤖 this file was generated by svg-to-ts */
export const iconSearch: {
    name: 'search';
    data: string;
} = {
    name: 'search',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21"><path fill="#000" fill-rule="nonzero" d="M7.882.51a7.371 7.371 0 0 1 5.415 12.373l6.008 6.008a.65.65 0 0 1-.839.988l-.08-.069-6.054-6.052A7.372 7.372 0 1 1 7.882.51m0 1.3a6.072 6.072 0 1 0 0 12.144 6.072 6.072 0 0 0 0-12.144"/></svg>`
};
